import { getAttributeBySlug } from '~src/modules/attributes/reducers/attributes.reducer';
import { StoreI } from '~src/rootReducer';
import { AttrSlugType, AttributeI } from '~src/interfaces/attributes.types';

export function getTimezoneAttribute(state: StoreI): AttributeI {
  return getAttributeBySlug(state, AttrSlugType.Timezone);
}

export function getSystemLanguageAttribute(state: StoreI): AttributeI {
  return getAttributeBySlug(state, AttrSlugType.SystemLanguage);
}

export function getContentLanguageAttribute(state: StoreI): AttributeI {
  return getAttributeBySlug(state, AttrSlugType.ContentLanguage);
}

export function getManagerAttribute(state: StoreI): AttributeI {
  return getAttributeBySlug(state, AttrSlugType.Manager);
}

export function getRecommendationsAttribute(state: StoreI): AttributeI {
  return getAttributeBySlug(state, AttrSlugType.AIRecommendations);
}
